import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Heart, History } from 'lucide-react';
import { usePlatform } from '../store';

export function AtlasShell({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  const { data } = usePlatform();
  const favorites = data?.favorites.length || 0;
  return (
    <div className={`atlas-layout ${className}`}>
      <aside className="atlas-sidebar">
        <nav className="atlas-shortcuts" aria-label="我的游戏">
          <NavLink to="/recent">
            <History size={19} />
            最近玩过
          </NavLink>
          <NavLink to="/favorites">
            <Heart size={19} />
            我的收藏{favorites > 0 && <span>{favorites}</span>}
          </NavLink>
        </nav>
      </aside>
      <div className="atlas-main">{children}</div>
    </div>
  );
}

export function AtlasPageHeading({
  title,
  meta,
  children,
  scene,
  subtitle,
}: {
  title: string;
  meta?: string;
  children?: ReactNode;
  scene?: 'library' | 'rankings' | 'community';
  subtitle?: string;
}) {
  const scenes = {
    library: 'library-harbour',
    rankings: 'rankings-beacon',
    community: 'community-courtyard',
  };
  if (scene)
    return (
      <header className={`atlas-page-heading atlas-chapter-heading chapter-${scene}`}>
        <div className="atlas-chapter-copy">
          <div className="atlas-chapter-title">
            <h1>{title}</h1>
            {meta && <span role="status">{meta}</span>}
          </div>
          {subtitle && <p>{subtitle}</p>}
          {children && <div className="atlas-chapter-actions">{children}</div>}
        </div>
        <img
          className="atlas-chapter-art"
          src={`/art/island-atlas-v9/${scenes[scene]}.webp`}
          width="1440"
          height="600"
          alt=""
          aria-hidden="true"
          onError={(event) => {
            event.currentTarget.hidden = true;
          }}
        />
      </header>
    );
  return (
    <header className="atlas-page-heading">
      <div>
        <h1>{title}</h1>
        {meta && <span role="status">{meta}</span>}
      </div>
      {children}
    </header>
  );
}
